<div class="capital-background capital-wrapper-container">
    <div class="position-absolute top-0 end-0 d-none d-lg-block" style="z-index: 1000;">
        <img class="capital-logo" src="img/logo.svg" alt="Capital logo" (click)="onLogoClick()" (keydown.enter)="onLogoClick()" style="cursor: pointer;">
    </div>
    <div class="d-flex justify-content-center align-items-center capital-wrapper" [class.compact-top]="compactTop()">
        <div [class]="'capital-container border border-white ' + size()" [ngClass]="{ 'capital-paddings': !disablePaddings() }">
            <ng-content></ng-content>
        </div>
    </div>
</div>